import { useMemo, useRef, useEffect } from 'react'
import PaginatedPage from '../../components/PaginatedPage'
import TableView from '../../components/TableView'
import BasicDateRenderer from '../../utils/renderers'

import './translations'
import ResponsibilitiesPresenter from '../../api/responsibilitiesPresenter'
import ResponsibilitiesUpsertForm from './ResponsibilitiesUpsertForm'
import usePermissions from '../../components/usePermissions'
import useTranslate, { t } from '../../hooks/useTranslate'
import { useWindowContext } from '@iqueue/ui-kit'

export function ResponsibilitiesTable(props) {
  const { permissions } = usePermissions()
  const locale = useTranslate()

  const tableRef = useRef()

  const schema = useMemo(() => [{
    key: 'name',
    title: t('responsibilitiesPage.table.profileName'),
    render: (v, item) => {
      return <span>{ item.profile.name + ' ' + item.profile.surname }</span>
    },
  }, {
    key: 'number',
    title: t('user.form.phoneNumber'),
    render: (v, item) => <span>{ item?.profile?.phoneNumber || 'N/A' }</span>,
    width: '20rem',
  }, {
    key: 'node',
    title: t('responsibilitiesPage.table.node'),
    render: (v, item) => <span>{ item?.node?.name || 'N/A' }</span>,
    width: '20rem',
  }, {
    key: 'sensor',
    title: t('responsibilitiesPage.table.sensor'),
    render: (v, item) => {
      return <span>{ item.sensorId && item.sensor.devEUI || 'N/A' }</span>
    },
    width: '20rem',
  }, {
    key: 'updatedAt',
    title: t('responsibilitiesPage.table.updatedAt'),
    render: BasicDateRenderer,
    width: '20rem',
  }, {
    key: 'createdAt',
    title: t('responsibilitiesPage.table.createdAt'),
    render: BasicDateRenderer,
    width: '20rem',
  }], [t, locale])

  return <TableView
    ref={ tableRef }
    permissions={ permissions[ResponsibilitiesPresenter.key.toUpperCase()] }
    form={ ResponsibilitiesUpsertForm }
    schema={ schema }
    entity={ 'responsibility' }
    minWidth={ '125rem' }
    { ...props }
  />
}

export default function ResponsibilitiesPage() {
  const { setTitle, togglePaddings, toggleScrollbars } = useWindowContext()
  const locale = useTranslate()
  const translatedTitle = useMemo(() => t('menu.responsibility'), [locale])

  useEffect(() => {
    setTitle(translatedTitle)
    togglePaddings(false)
    toggleScrollbars(true)
  }, [translatedTitle])

  return <PaginatedPage
    presenter={ ResponsibilitiesPresenter }
    component={ ResponsibilitiesTable }
  />
}
